import { createVanIconComponent } from "./van"

const Chat = createVanIconComponent("chat")
export default Chat
